import SectionWrapper from './SectionWrapper';
import { Flex, Link, Text } from '@chakra-ui/react';
import { useAppDispatch, useAppSelector } from '../../../store/redux/hooks';
import { addBeacon } from '../../../store/redux/slices/template.slice';
import BeaconWrapper from './BeaconWrapper';
import AddMoreButton from './AddMoreButton';

const BeaconsFeature = () => {
  const beacons = useAppSelector((s) => s.template.beacons);
  const dispatch = useAppDispatch();

  const limitReached = beacons.length >= 10;

  return (
    <SectionWrapper
      id="beacons-section"
      title="iBeacons"
      tooltip="Let users receive notifications when they enter the proximity of a beacon."
      subtitle={
        <Text>
          View the{' '}
          <Link
            color="linkBlue"
            href="https://docs.passentry.com/documentation/passes/geofencing/guide"
            target="_blank"
          >
            geofencing guide
          </Link>{' '}
          for more information.
        </Text>
      }
      autoOpenOnceWhen={beacons.length > 0}
    >
      <Flex direction="column" gap={4}>
        {beacons.length > 0 && (
          <Flex direction="column" gap={4}>
            {beacons.map((beacon, index) => (
              <BeaconWrapper
                key={beacon._id}
                beacon={beacon}
                index={index}
                newlyAdded={beacon._newlyAdded}
              />
            ))}
          </Flex>
        )}

        {!limitReached && (
          <AddMoreButton
            text="Add beacon"
            onClick={() => dispatch(addBeacon())}
          />
        )}
      </Flex>
    </SectionWrapper>
  );
};

export default BeaconsFeature;
